<div class="container-fluid spacer-top-navigation">
  <div class="container">
    <div class="row mb-4">
      <div class="col-12">
        <web-components-user-notes target="account-overview" [dismissibleNotes]="true" />
      </div>
      <div class="col-12">
        <h1 class="zero-text p-huge-med">{{ 'account.page-title' | transloco }}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <depot-money-transaction-overview />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <depot-money-transaction />
        </div>
      </div>
    </div>
  </div>
</div>
